export enum ReservationStatus {
  CANCELLED_BY_CUSTOMER = 'cancelled_by_customer',
  CANCELLED_BY_LOCATION = 'cancelled_by_location',
  CONFIRMED = 'confirmed',
  EXPECTED = 'expected',
  REQUESTED = 'requested',
  SEATED = 'seated',
  SUGGESTED = 'suggested',
}

export interface Reservation {
  cover: number
  id: string
  note?: string | null
  reservationAt: string
  sid: string
  status: ReservationStatus
}
